import { useEffect } from 'react'
import { isBlackScreenKey } from './model/presenter-keys'

/** The console's `B` / `.` key, while `toggle` is given. */
export const useBlackScreenKey = (toggle: (() => void) | undefined): void => {
	useEffect(() => {
		if (!toggle) {
			return
		}
		const onKeyDown = (event: KeyboardEvent): void => {
			if (isBlackScreenKey(event)) {
				event.preventDefault()
				toggle()
			}
		}
		window.addEventListener('keydown', onKeyDown)
		return () => window.removeEventListener('keydown', onKeyDown)
	}, [toggle])
}
